import {
  FilterType,
  TeamsTeam,
  buildEmployeePulseEmployeeDatatableFilter,
  useEmployeePulseEmployeeDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const teamFilter = (
  source: ReturnType<typeof useEmployeePulseEmployeeDatatable>,
  teams: Pick<TeamsTeam, 'id' | 'name'>[]
) => {
  return buildEmployeePulseEmployeeDatatableFilter(source, {
    title: i18n.t('engagement.pulse.dashboard.datatable.filters.team'),
    path: 'teamId',
    identifier: 'teamId',
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: teams.map(({ name, id }) => ({ label: name, value: id })),
      },
    ],
  })
}

export default teamFilter
